<template>
  <div class="outdated-paid-refunded">
    <h2 class="normal" v-html="$t('confirmation.outdatedPaidRefunded.header')"></h2>
    <p v-html="$t('confirmation.outdatedPaidRefunded.description')"></p><p v-html="$t('confirmation.outdatedPaidRefunded.description2')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationOutdatedPaidRefunded'
}
</script>
